import { useCallback, useRef, useState } from 'react';
import { useEffect, createElement } from 'react';
import { PAGInit } from 'libpag';
import './style.less';
function PagImg(props) {
    const { url, defaultImg, className = '' } = props;
    const canvasRef = useRef(null);
    const [isSupported, setIsSupported] = useState(false);
    const [showCanvas, setShowCanvas] = useState(false);
    const isWebGLSupported = useCallback(() => {
        try {
            const canvas = document.createElement('canvas');
            return !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
        }
        catch (e) {
            return false;
        }
    }, []);
    useEffect(() => {
        if (!isWebGLSupported() || !url) {
            console.warn('您的浏览器不支持 WebGL，无法播放动画');
            setIsSupported(false);
            return;
        }
        setIsSupported(true);
        PAGInit().then((PAG) => {
            fetch(url)
                .then((response) => {
                if (!response.ok) {
                    throw new Error('加载失败');
                }
                return response.arrayBuffer();
            })
                .then(async (buffer) => {
                if (!canvasRef.current) {
                    console.warn('Canvas 元素未找到！');
                    return;
                }
                const pagFile = await PAG.PAGFile.load(buffer);
                canvasRef.current.width = pagFile.width();
                canvasRef.current.height = pagFile.height();
                const pagView = await PAG.PAGView.init(pagFile, canvasRef.current).catch((error) => {
                    console.error('libpag 初始化失败:', error);
                });
                pagView.setRepeatCount(0);
                await pagView.play();
                setShowCanvas(true);
            })
                .catch((e) => {
                console.error('libpag 播放失败. ', e);
                setIsSupported(false);
            });
        });
    }, [url]);
    return (createElement("div", { className: `pag-img-wrap ${className}` },
        isSupported ? (createElement("canvas", { id: "pag", ref: canvasRef, style: { display: showCanvas ? 'initial' : 'none' } })) : null,
        createElement("img", { src: defaultImg, style: { display: showCanvas ? 'none' : 'initial' } })));
}
export default PagImg;
